import { getTenantFromPath } from '../utils/common';

export const loginInitialState = {
  // authChecked: завершена ли первичная проверка сессии (probe /me).
  // Пока проверка не завершена, PrivateRoute показывает лоадер, а не уводит на OIDC-логин.
  authChecked: false,
  authenticated: false,
  tenants: [],
  tenantId: '',
  sessionExpiresAt: null, // epoch ms из /me; основа таймера проактивной реаутентификации.
};

const login = (state = loginInitialState, action) => {
  switch (action.type) {
    case 'SET_TENANT_ID':
      return {
        ...state,
        tenantId:
          [...(state.tenants || []), ''].find((t) => t === action.tenantId) || state.tenantId,
      };

    case 'UPDATE_LOCATION':
      return {
        ...state,
        tenantId:
          [...(state.tenants || []), ''].find((t) => t === getTenantFromPath(action.location)) ||
          state.tenantId,
      };

    // probe /me: успех = валидная OIDC-сессия; tenants берём из ключей permissionsByTenant.
    case 'FETCH_ME_SUCCESS':
      return {
        ...state,
        authChecked: true,
        authenticated: true,
        tenants: Object.keys(action.permissionsByTenant || {}),
        sessionExpiresAt: action.sessionExpiresAt || null,
      };

    case 'FETCH_ME_FAILURE':
      return {
        ...state,
        authChecked: true,
      };

    case 'LOGOUT':
      return {
        ...loginInitialState,
        authChecked: true,
      };

    default:
      return state;
  }
};

export default login;

export const getTenantId = (state) => state.tenantId;

export const getTenants = (state) => state.tenants;

export const isAuthenticated = (state) => state.authenticated;

export const isAuthChecked = (state) => state.authChecked;

export const getSessionExpiresAt = (state) => state.sessionExpiresAt;
